// for de/serializing download grid filters to/from the location query string
export default {
	serialize: store => {
		if (history.pushState) {
			const parts = [];
			const {selectedFiltersGrouped, selectedArea} = store;
			for (const k in selectedFiltersGrouped) {
				if (selectedFiltersGrouped.hasOwnProperty(k)) {
					const group = selectedFiltersGrouped[k];
					parts.push(`${k}=${group.map(f => f.key).join(',')}`);
				}
			}
			parts.push(`area=${selectedArea.key}`);
			const q = parts.length > 0 ? `?${parts.join('&')}` : '';
			const l = document.location;
			const url = `${l.protocol}//${l.host}${l.pathname}${q}`;
			window.history.pushState({path: url}, '', url);
		}
	},
	unserialize: store => {
		const query = document.location.search;
		if (query.length > 0) {
			const params = query.substring(1).split('&').reduce((acc, pair) => {
				const parts = pair.split('=');
				if (parts.length === 2) {
					const [k, v] = parts;
					acc[k] = decodeURIComponent(v);
				}
				return acc;
			}, {});
			store.setSelectedArea(params.area? params.area : '', false);
			for (const k in params) {
				if (params.hasOwnProperty(k)) {
					if (k === 'area') continue;
					for (const tag of params[k].split(',')) {
						store.toggleFilter(tag, false);
					}
				}
			}
		} else {
			store.setSelectedArea('');
		}
	}
};
